// External imports
import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
// Local imports
import ReactTable from "../../../components/FilterTable";
import { Button, Modal } from "react-bootstrap";
import { IoIosEye } from "react-icons/io";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
const Grid = (props) => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorDetails, setErrorDetails] = useState([]);
  useEffect(() => {
    let gridDataList = props.gridTaskData;
    if (gridDataList.length > 0) {
      gridDataList.map((data) => {
        data.FileProcessRcvdDate = moment(data.FileProcessRcvdDate).format(
          "MM/DD/YYYY hh:mm:ss A"
        );
        data.FileProcessStartDate = moment(data.FileProcessStartDate).format(
          "MM/DD/YYYY hh:mm:ss A"
        );
        data.FileProcessEndDate = data.FileProcessEndDate
          ? moment(data.FileProcessEndDate).format("MM/DD/YYYY hh:mm:ss A")
          : data.FileProcessEndDate;
        // data.FileSize = formatFileSize(data.FileSize);
      });
    }
    setGridData(gridDataList);
  }, [props, gridData]);
  const columns = [
    {
      Header: "Task Name",
      accessor: "TaskName",
      filter: "TaskName",
      sortType: "basic",
    },
    {
      Header: "File Name",
      accessor: "FileName",
      filter: "FileName",
      sortType: "basic",
      width: 270,
      Cell: ({ row: { original } }) => (
        <Fragment>
          <span className="word-wrap">{original.FileName}</span>
        </Fragment>
      ),
    },
    {
      Header: "File Received/Generated Timestamp",
      accessor: "FileProcessRcvdDate",
      filter: "FileProcessRcvdDate",
      sortType: "basic",
    },
    {
      Header: "Process Start Timestamp",
      accessor: "FileProcessStartDate",
      filter: "FileProcessStartDate",
      sortType: "basic",
    },
    {
      Header: "Process End Timestamp",
      accessor: "FileProcessEndDate",
      filter: "FileProcessEndDate",
      sortType: "basic",
    },
    {
      Header: "Elapsed Time",
      accessor: "ElapsedTime",
      filter: "ElapsedTime",
      sortType: "basic",
      width: 180,
    },
    {
      Header: "File Size",
      accessor: "FileSize",
      filter: "FileSize",
      sortType: "basic",
      width: 90,
      Cell: ({ row: { original } }) => (
        <Fragment>
          <span>{formatFileSize(original.FileSize)}</span>
        </Fragment>
      ),
    },
    {
      Header: "Row Count",
      accessor: "FileRowCount",
      filter: "FileRowCount",
      sortType: "basic",
      width: 120,
    },
    {
      Header: "Status",
      accessor: "Status",
      filter: "Status",
      sortType: "basic",
      width: 140,
    },
    {
      Header: "Errors / Comments",
      accessor: "ErrorDescription",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row: { original } }) => (
        <Fragment>
          {original.ErrorDescription == "N/A" ||
          original.ErrorDescription == null ? (
            "N/A"
          ) : (
            <Button
              variant="link"
              onClick={() => viewErrors(original.FileProcessId)}
              className="grid-action-btn ml-2"
              title="View Task"
            >
              <IoIosEye className="icon" />
            </Button>
          )}
        </Fragment>
      ),
    },
  ];
  const data = [];
  const errorDetaileColumns = [
    {
      Header: "Timestamp",
      accessor: "ErrorCreatedDate",
    },
    {
      Header: "File Name",
      accessor: "FileProcessName",
    },
    {
      Header: "Error Description",
      accessor: "ErrorDescription",
    },
  ];

  // Format file size to kb
  const formatFileSize = (bytes) => {
    if (bytes === 0 || bytes === null) {
      let size = 0 + " " + "Bytes";
      return size;
    } else {
      var k = 1000,
        dm = 2,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
  };
  const viewErrors = (fileProcessID) => {
    setShow(true);
    setLoading(true);
    _HttpServices
      .getData(`Api/Chart/GetFileProcessesErrors?processesID=${fileProcessID}`)
      .then((data) => {
        const errorDetails = data.data;
        if (errorDetails.length > 0) {
          errorDetails.map((res) => {
            res.ErrorCreatedDate = moment(res.ErrorCreatedDate).format(
              "MM/DD/YYYY h:mm:ss A"
            );
          });
        }
        setErrorDetails(errorDetails);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };
  const handleClose = () => setShow(false);
  return (
    <div className="dashboard-grid">
      <Fragment>
        {gridData.length > 0 ? (
          <ReactTable columns={columns} data={gridData} defaultPageSize={10} />
        ) : (
          <div className="no-data">No data found.</div>
        )}
        <Button onClick={props.showChart} className="float-right mb-3">
          Cancel
        </Button>
      </Fragment>
      {/* model */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton><h4 className="h4">View Error</h4></Modal.Header>
        <Modal.Body>
          <div className="card pt-2">     
            <div className="card-body">
              <div className="inventory-grid">
                <Fragment>
                  {loading ? (
                    <Loader />
                  ) : errorDetails.length > 0 ? (
                    <ReactTable
                      columns={errorDetaileColumns}
                      data={errorDetails}
                      defaultPageSize={10}
                    />
                  ) : (
                    <div className="no-data">No data found.</div>
                  )}
                </Fragment>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(Grid);
